




import Vue from 'vue'
import activeInfoPage from '@/components/Ui/ActiveInfoPage/ActiveInfoPage.vue'
import StudentActiveInfoPage from '@/activePages/Student/Profile'
import Student from '@/models/Students/Student'

export default Vue.extend({
  name: 'StudentProfile',
  props: {
    id: String
  },
  data () {
    return {
      config: StudentActiveInfoPage
    }
  },
  components: {
    activeInfoPage
  },
  computed: {
    student (): Student {
      return this.$store.state.students.students[this.id]
    }
  }
})
